<div class="pos-header-ops" role="group" [attr.aria-label]="'pos.shell.opsGroup' | translate">
  @if (!shiftRequired()) {
    <!-- Con turno de caja (venta directa) el turno de propinas se abre/cierra
         junto con él desde un solo diálogo — este chip queda oculto para no duplicar. -->
    <button
      type="button"
      class="pos-header-ops__chip"
      [class.pos-header-ops__chip--warn]="tipShiftBlocked() && !tipShiftSetupIncomplete()"
      [class.pos-header-ops__chip--info]="tipShiftSetupIncomplete()"
      [class.pos-header-ops__chip--ok]="tipShiftActive()"
      (click)="openTipShift()"
      [attr.title]="tipShiftButtonLabelKey() | translate"
    >
      <mat-icon aria-hidden="true">{{ tipShiftButtonIcon() }}</mat-icon>
      <span class="pos-header-ops__label pos-header-ops__label--full">{{
        tipShiftButtonLabelKey() | translate
      }}</span>
      <span class="pos-header-ops__label pos-header-ops__label--compact">{{
        (tipShiftActive() ? 'pos.tipShift.activeCompact' : tipShiftButtonLabelKey()) | translate
      }}</span>
    </button>
  }

  @if (showCashShiftChip()) {
    <button
      type="button"
      class="pos-header-ops__chip"
      [class.pos-header-ops__chip--warn]="cashShiftBlocked()"
      [class.pos-header-ops__chip--ok]="cashShiftOpen()"
      (click)="openCashShift()"
      [attr.title]="cashShiftButtonLabelKey() | translate"
      [attr.aria-label]="cashShiftButtonLabelKey() | translate"
    >
      <mat-icon aria-hidden="true">{{ cashShiftButtonIcon() }}</mat-icon>
      <span class="pos-header-ops__label pos-header-ops__label--full">{{
        cashShiftButtonLabelKey() | translate
      }}</span>
      <span class="pos-header-ops__label pos-header-ops__label--compact">{{
        cashShiftButtonCompactKey() | translate
      }}</span>
    </button>
  }

  @if (staff(); as current) {
    <button
      type="button"
      class="pos-header-ops__chip pos-header-ops__chip--operator"
      (click)="onOperatorClick()"
      [attr.title]="'pos.staff.changeOperatorTitle' | translate"
    >
      <mat-icon>badge</mat-icon>
      <span class="pos-header-ops__operator-name">{{ current.name }}</span>
    </button>
  }
</div>
